import { HttpClient } from "@/App/services";
import config from "@/App/config";

export const BroadcastMessagesService = {
  sendMessage(message: any): Promise<any> {
    return HttpClient.post({
      path: `/notification/broadcast-message`,
      data: message,
      rewriteBaseUrlWith: config.API_URL
    });
  },
  getBroadcastMessages(channelIds: Array<string>): Promise<any> {
    return HttpClient.get({
      path: `/notification/broadcast-messages-history?channelIds=${channelIds.join()}&filterDuplicates=true`,
      rewriteBaseUrlWith: config.API_URL
    });
  },

  getPubnubSubscriptionKeys(): Promise<any> {
    return HttpClient.get({ path: `/secret`, rewriteBaseUrlWith: config.API_URL });
  }
};
